<template>
  <div
    id="eChartLine"
    class="chart-box"
    style="width:98%;height:83%;"
  >
  </div>
</template>

<script>

import echarts from 'echarts'
import { getDataCommon } from "common/js/http/v3Api";
export default {
  props: {
    country: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      id: 'F01_04',
      pagesize: 10,
      begindate: null,
      enddate: null,
      other: null,
      chartLine: null,
      datelist: [],
      gdplist: [],
      cpilist: [],
      m2list: [],
      gdplabel: null,
      cpilabel: null,
      m2label: null,
    }
  },
  watch: {
    gdplist(n, o) {
      this.initChart()
    },
    cpilist(n, o) {
      this.initChart()
    },
    m2list(n, o) {
      this.initChart()
    }
  },
  mounted() {
    this.getDataCommon()
  },
  activated() {
    // 由于给echart添加了resize事件, 在组件激活时需要重新resize绘画一次, 否则出现空白bug
    if (this.chartLine) {
      this.chartLine.resize()
    }
  },
  methods: {
    // 折线图
    initChart() {
      var option = {
        'color': ['#3fb1e3', '#cc70af', '#ffb980', '#9b8bba',
          '#e098c7', '#97b552', '#d87a80', '#eedd78',
          '#2ec7c9', '#626c91', '#cbb0e3', '#73a373', '#8dc1a9',
          '#97d4dc', '#82c0c9', '#b7dba1', '#a0a7e6', '#6be6c1'],
        'tooltip': {
          'trigger': 'axis',
          backgroundColor: '#9ca0a9',
          axisPointer: {
            type: 'line',
            lineStyle: {
              width: '0.5',
              type: 'dashed'
            }
          },
          formatter: (params) => {
            var str = ''
            str += 'Date：' + params[0].axisValue + '<br />'
            if (params[0] != null && params[0].value !== '') {
              str += '' + params['0'].seriesName.replace('(%)', '') + '：' + params['0'].value + '%<br />'
            }
            if (params[1] != null && params[1].value !== '') {
              str += '' + params['1'].seriesName.replace('(%)', '') + '：' + params['1'].value + '%<br />'
            }
            if (params[2] != null && params[2].value !== '') {
              str += '' + params['2'].seriesName.replace('(%)', '') + '：' + params['2'].value + '%<br />'
            }
            return str
          }
        },
        'legend': {
          'textStyle': {
            'fontSize': '12',
            'color': '#636363'
          },
          'data': [{ 'name': 'GDP YoY(%)', 'icon': 'rect' }, { 'name': 'CPI YoY(%)', 'icon': 'rect' }, { 'name': 'M2 YoY(%)', 'icon': 'rect' }],
          'itemWidth': 17,
          'itemHeight': 3,
          'left': '20',
          'top': '25'
        },
        'grid': {
          x: 40,
          y: 70,
          x2: 35,
          y2: 30
        },
        'xAxis': {
          'type': 'category',
          'boundaryGap': false,
          'data': this.datelist,
          axisTick: {
            show: true,
            lineStyle: {
              color: '#DFE1E5'
            }
          },
          axisLine: { show: false }
        },
        'yAxis': {
          name: '%',
          'type': 'value',
          scale: true,
          axisLine: { show: false },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#dfe1e5']
            }
          }
        },
        'series': [
          {
            'name': 'GDP YoY(%)',
            'type': 'line',
            showSymbol: false,
            connectNulls: true,
            symbolSize: 0.5,
            symbol: 'circle',
            'data': this.gdplist
          },
          {
            'name': 'CPI YoY(%)',
            'type': 'line',
            connectNulls: true,
            showSymbol: false,
            symbolSize: 0.5,
            symbol: 'circle',
            'data': this.cpilist
          },
          {
            'name': 'M2 YoY(%)',
            'type': 'line',
            connectNulls: true,
            showSymbol: false,
            symbolSize: 0.5,
            symbol: 'circle',
            'data': this.m2list
          }
        ]
      }
      this.chartLine = echarts.init(document.getElementById('eChartLine'))
      this.chartLine.setOption(option)
      window.addEventListener('resize', () => {
        this.chartLine.resize()
      })
    },
    async getDataCommon() {
      const { data } = await getDataCommon({
        'fcode': 'F01_04',
        'countryCode': this.country.countryCode,
        'pagesize': this.pagesize,
        't': new Date().getTime(),
        'other': this.other,
        'locales': 'en'
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '2CCA56D9D84849551E943895153D5AD5' });
      let echartData = data.result.data
      if (echartData != null && echartData.length !== 0) {
        this.datelist = echartData[0].DATADATE.split(',').map(item => item.replace(/\'/g, ''))
        this.gdplist = echartData[0].value_01.split(',').map(item => item.replace(/\'/g, ''))
        this.cpilist = echartData[0].value_02.split(',').map(item => item.replace(/\'/g, ''))
        this.m2list = echartData[0].value_03.split(',').map(item => item.replace(/\'/g, ''))
        this.gdplabel = echartData[0].label_01.split(',').map(item => item.replace(/\'/g, ''))
        this.cpilabel = echartData[0].label_02.split(',').map(item => item.replace(/\'/g, ''))
        this.m2label = echartData[0].label_03.split(',').map(item => item.replace(/\'/g, ''))
      }
      this.initChart()
    }
  }
}
</script>

<style scoped>
</style>
